import { get, patch, post } from "./api";

export const fetchCustomerFileRequests = (customer_id, params = {}) => {
  return get(`/api/v2/customers/${customer_id}/filerequests/`, params);
};

export const createFileRequest = (customer_id, data) => {
  return post(`/api/v2/customers/${customer_id}/filerequests/`, data);
};

export const updateFileRequest = (customer_id, id, data) => {
  return patch(
    `/api/v2/customers/${customer_id}/filerequests/${id}/`,
    data,
    "multipart/form-data"
  );
};
